<div class="category-container">
    <div class="div-container">
        <div class="page-title"><button [routerLink]="['/basket']"><i class="fa-solid fa-chevron-left"></i>
                zurück</button>{{categoryTitle}}<i class="fa-solid fa-house home" (click)="fallback()"></i>
        </div>
        <div class="products" *ngIf="products">
            <div class="product-options">
                <div class="option" *ngFor="let product of products" (click)="selectedProduct = product">
                    <div class="promotion" *ngIf="product.discountedPrice !== product.baseUnitPrice">%</div>
                    <img [ngStyle]="{'visibility': product.image ? 'visible' : 'hidden'}" [ngClass]="{'default':product.image?.toString()?.endsWith('.svg')}" [src]="product.image">
                    <p >{{product.description}}
                    </p>
                    <p>CHF <span
                            [ngStyle]="{'color': product.discountedPrice  !== product.baseUnitPrice ? '#ff0000':'#004681'}">{{(product.discountedPrice
                            !== product.baseUnitPrice
                            ? product.discountedPrice: product.baseUnitPrice) | number:'1.2-2'}}</span><span
                            class="old-price" *ngIf="product.discountedPrice !== product.baseUnitPrice">{{'
                            ('+(product.baseUnitPrice |
                            number:'1.2-2')+')'}}</span></p>
                </div>
            </div>
        </div>
    </div>
    <div #modal class="modal" *ngIf="selectedProduct">
        <div class="modal-body">
            <div class="modal-content">
                <div class="close" (click)="close()"><i class="fa-solid fa-circle-xmark"></i>schliessen</div>
                <div class="selection-details">
                    <img  [ngClass]="{'default':selectedProduct.image!.toString().endsWith('.svg')}"
                        [src]="selectedProduct.image">
                    <div class="sub-details">{{selectedProduct.description}}
                    </div>
                    <div class="edits"><i class="fa-solid fa-circle-minus"
                            (click)="quantity = quantity > 1 ? quantity - 1 : 1"></i>
                        <div>{{quantity + ' x CHF ' + (selectedProduct.discountedPrice ? selectedProduct.discountedPrice
                            : selectedProduct.baseUnitPrice | number:'1.2-2')}}</div><i class="fa-solid fa-circle-plus"
                            (click)="quantity = quantity + 1"></i>
                    </div>
                </div>
            </div>
            <div class="submit" (click)="submit()"><i class="fa-solid fa-circle-check"></i>In den Warenkorb
            </div>
        </div>
    </div>
</div>